import React, { useState, useEffect } from 'react'
import Times from '../Times'

// import Heading from '../Heading'
type Input = {
  value: string | boolean | number
  setValue: (newValue) => void
}
const times = [
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
]
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
const PlanningStepTwo: React.FC<{
  input: Input[]
  variant: string
  day: number
  month: string
}> = ({ input, variant, day, month }) => {
  const monthName = months[month]
  return (
    <>
      <Times
        day={day}
        monthName={monthName}
        setTime={input[0].setValue}
        selectedTime={input[0].value}
        times={times}
      />
    </>
  )
}

export default PlanningStepTwo
